import { Product } from 'common/interfaces/agg-page';
import { noop } from 'common/utils';
import { Context, createContext, useContext } from 'react';

import { AiVariant, AiVariantContext, AiVariantMap, MelFields } from '../types/common';

export interface IMelContext {
  aiVariants: {
    aiVariantPageMap: AiVariant[];
    aiVariantProductMap: AiVariant[];
  };
  award?: string;
  currentProduct: Product;
  handleRegeneratePage: () => void;
  handleRequestVariant: (context?: AiVariantContext) => void;
  selectedVariant: AiVariant;
  setCurrentFieldName: React.Dispatch<React.SetStateAction<MelFields>>;
  setCurrentProduct: React.Dispatch<React.SetStateAction<Product>>;
  setSelectedVariant: React.Dispatch<React.SetStateAction<AiVariant>>;
  variantsMap: AiVariantMap;
}

const MelContext: Context<IMelContext> = createContext<IMelContext>({
  aiVariants: {} as any,
  award: undefined,
  currentProduct: {} as any,
  handleRegeneratePage: noop,
  handleRequestVariant: noop,
  selectedVariant: {} as any,
  setCurrentFieldName: noop,
  setCurrentProduct: noop,
  setSelectedVariant: noop,
  variantsMap: {} as any,
});

const useMelContext = (): IMelContext => useContext(MelContext);

export { MelContext, useMelContext };
